var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',[_c('strong',[_vm._v("Account: "+_vm._s(_vm.account_num))]),_vm._v(", Welcome back "+_vm._s(_vm.user_name)+"!")])])]),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('b-card',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlIFrame)}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/Dashboard.vue?vue&type=template&id=0cc883b4&
// module id = null
// module chunks = 